/** Demo entries for the customer-search panel.
 *
 * Every `consumer_id` here is a REAL consumer on the DEV backend. Tapping a row sets `scannedQr`,
 * and `ScanFlow` immediately calls `GET /customer?webext_uuid=…&qr=<uid>`; an invented uid fails
 * that call and drops the tester on the error screen instead of the marketplace. So a uid here
 * has to resolve — that is the whole point of the list. Each was checked before being added
 * (all HTTP 200, names exactly as `/customer` returns them).
 *
 * WHAT IS REAL AND WHAT IS NOT:
 *   - `consumer_id`  real, verified against DEV. Do not add an unverified one.
 *   - `display_name` real — mirrors `/customer`, so the name in this list is the name the next
 *                    screen shows.
 *   - `phone`/`email` real for Malik only. The rest are generated DEV test accounts with no
 *                    contact details, so their numbers below are INVENTED (deliberately
 *                    sequential, so they read as synthetic) purely so the Téléphone tab — the
 *                    panel's default — has something to search. Do not treat them as contact data.
 *   - `points_balance` ILLUSTRATIVE. `/customer` still answers in the stamp model (`cards`,
 *                    `stamps`); the points shape is TechSpec B2 and is not served yet. All of
 *                    these accounts currently hold zero cards and zero rewards anyway.
 *
 * To add someone: paste their uid, confirm it 200s on `/customer`, and give them a phone if you
 * want the Téléphone tab to find them.
 */
import type { SearchCustomer } from '../api/types'

export const FIXTURE_CUSTOMERS: SearchCustomer[] = [
  {
    consumer_id: 'rVZ70CnHalVoz2TmRoJ9pW625Y03',
    display_name: 'Malik Berhili',
    phone: '+41 79 686 89 65',
    email: 'malik@badgercards.ch',
    // Kept equal to FIXTURE_CUSTOMER.points_balance — this is the balance a participant sees BEFORE
    // picking the customer, and the marketplace shows that one after. Different numbers read as the
    // balance changing under them.
    points_balance: 2300,
  },
  {
    consumer_id: 'IH9roK4IiCUVZSu9nlHc7kLhkxv1',
    display_name: 'BatingoStage',
    phone: '079 100 00 01',
    points_balance: 310,
  },
  {
    consumer_id: '0Isd9VgMH3OFU88VY80jz2ZVmIm2',
    display_name: 'empathicCake80',
    phone: '079 100 00 02',
    points_balance: 940,
  },
  {
    consumer_id: '0NS3A0wG9lZdkLoCyDoVCecPR7N2',
    display_name: 'testGod',
    phone: '079 100 00 03',
    points_balance: 2680,
  },
  {
    consumer_id: '1ujdTrU4F2YoPN0KXOxYIycwW7k2',
    display_name: 'amusedEggs41',
    phone: '079 100 00 04',
    points_balance: 75,
  },
  {
    consumer_id: '1zS5iZNRJ4bGMs3ISb9eWchK5o63',
    display_name: 'relievedWhiting02',
    phone: '079 100 00 05',
    points_balance: 5120,
  },
]
